import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import * as fromActions from './ui.actions';
import * as fromSelectors from './ui.selectors';
import { UiState } from './ui.reducer';
import { Store } from '@ngrx/store';

@Injectable()
export class UiEffects {
  constructor(private actions$: Actions, private store: Store<{ ui: UiState }>) {}
}
